import React, { createContext, useContext } from 'react'
import { FormComposerStore } from '../Stores/FormComposerStore'

/**
 * Створює новий екземпляр FormComposerStore
 */
export const createFormComposerContext = (props: any = {}): FormComposerStore => {
    const config: {
        submitOrder?: string[]
    } = {}

    if (Array.isArray(props.submitOrder)) {
        config.submitOrder = props.submitOrder
    }

    return new FormComposerStore(config)
}

/**
 * React Context для FormComposerStore
 */
export const FormComposerContext = createContext<FormComposerStore | null>(null)

/**
 * Хук для отримання контексту композера форм
 */
export const useFormComposerContext = (): FormComposerStore => {
    const context = useContext(FormComposerContext)
    if (!context) {
        throw new Error('useFormComposerContext повинен використовуватись всередині FormComposerContextProvider')
    }
    return context
}

/**
 * Хук для опціонального отримання контексту композера форм
 * Повертає null якщо контекст не знайдено
 */
export const useOptionalFormComposerContext = (): FormComposerStore | null => {
    const context = useContext(FormComposerContext)
    return context || null
}

/**
 * Провайдер контексту композера форм
 */
export interface FormComposerContextProviderProps {
    value: FormComposerStore
    children: React.ReactNode
}

export const FormComposerContextProvider: React.FC<FormComposerContextProviderProps> = ({
    value,
    children,
}) => <FormComposerContext.Provider value={value}>{children}</FormComposerContext.Provider>
